import { render, staticRenderFns } from "./RegulationQuestions.vue?vue&type=template&id=3f6fb6b2&scoped=true&"
import script from "./RegulationQuestions.vue?vue&type=script&lang=js&"
export * from "./RegulationQuestions.vue?vue&type=script&lang=js&"
import style0 from "./RegulationQuestions.vue?vue&type=style&index=0&id=3f6fb6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fb6b2",
  null
  
)

export default component.exports